import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Jejuricabbooking() {



  const cardData =
  {
    keyword: 'Pune to Jejuri Cab Booking',
    heading: 'Sanavi Travels: Pune to Jejuri Cab Booking',
    headingDescription: 'Sanavi Travels offers reliable Pune to Jejuri Cab Booking, providing safe, comfortable, and hassle-free transportation for pilgrims, families, and groups traveling from Pune to the sacred Jejuri temple. Our fleet of sedans, SUVs, and luxury cabs is well-maintained with spacious seating, air-conditioning, and ample luggage space, ensuring a smooth and relaxed journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering Jejuri and nearby pilgrimage spots. Choose Sanavi Travels for trusted Pune to Jejuri cab booking services, delivering comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Jejuri with Sanavi Travels',


"topPlaces": [
  {
    "title": "Khandoba Temple",
    "description": "Jejuri is famous for the Khandoba Temple, dedicated to Lord Khandoba, a form of Lord Shiva. The temple, situated on a hill, is adorned with golden decorations and attracts thousands of devotees, especially during the annual Bhandara festival. Pilgrims often climb numerous steps to reach the shrine, seeking blessings and spiritual solace."
  },
  {
    "title": "Jejuri Fort",
    "description": "Jejuri Fort surrounds the Khandoba Temple and provides panoramic views of the surrounding hills and valleys. The fort’s ramparts, ancient walls, and scenic landscapes make it a popular spot for history enthusiasts and photographers visiting Jejuri."
  },
  {
    "title": "Malhar Temple",
    "description": "Malhar Temple is a smaller shrine near Jejuri, dedicated to Lord Shiva. Known for its tranquil surroundings and historic significance, it is often visited by devotees seeking peace and spiritual reflection in addition to the main Khandoba Temple."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "Bhuleshwar Temple, located a short distance from Jejuri, is a historic temple with ancient stone carvings and architectural significance. Though less visited, it is an important part of the region’s religious and cultural heritage."
  },
  {
    "title": "Local Market and Pilgrim Streets",
    "description": "The streets around Jejuri Temple are lined with shops selling religious souvenirs, sweets, and local handicrafts. Visiting these markets provides insight into local culture and traditions, making it a vibrant complement to the spiritual visit."
  },
  {
    "title": "Khandoba Hill Steps",
    "description": "The climb up to Khandoba Temple involves numerous stone steps, which are both a physical and spiritual journey. Along the way, pilgrims can enjoy scenic views, small shrines, and the natural beauty of the surrounding hills."
  },
  {
    "title": "Waghjai Waterfalls",
    "description": "Waghjai Waterfalls, located near Jejuri, is a seasonal waterfall that becomes especially spectacular during the monsoon. Surrounded by lush greenery, it is a serene spot for nature lovers and photography enthusiasts."
  },
  {
    "title": "Jejuri Scenic Viewpoints",
    "description": "Several viewpoints around Jejuri offer panoramic vistas of the surrounding Sahyadri hills and valleys. These spots are ideal for sunrise and sunset photography, trekking, and enjoying the natural beauty of the region."
  },
  {
    "title": "Historic Step Wells",
    "description": "Jejuri has a few ancient step wells and water reservoirs built to support pilgrims and locals. These structures showcase traditional engineering and are part of the town’s historic charm."
  },
  {
    "title": "Local Temples Circuit",
    "description": "Apart from Khandoba Temple, Jejuri has several smaller temples dedicated to various deities. Pilgrims often include these in their visit, creating a spiritual circuit that highlights the town’s rich religious heritage."
  }
]
,




"services": [
  {
    "name": "Pune to Jejuri Cab Booking",
    "description": "Pune to Jejuri Cab Booking provides a convenient and comfortable travel solution for pilgrims, tourists, and families traveling to Jejuri, home of the famous Khandoba Temple. These cabs ensure a smooth, air-conditioned ride from Pune with ample seating and luggage space. Professional chauffeurs with knowledge of the route make sure you reach your destination safely and on time. Perfect for one-day trips, religious visits, or family outings, this service combines comfort, safety, and reliability for a stress-free travel experience."
  },
  {
    "name": "Jejuri Cab from Pune",
    "description": "Jejuri Cab from Pune is designed for travelers seeking a hassle-free journey to the holy town of Jejuri. The cabs are fully air-conditioned, spacious, and equipped with comfortable seating for families, friends, or small groups. Chauffeurs are experienced and courteous, ensuring safe driving and timely arrivals. This service is ideal for religious visits, temple darshan, sightseeing, or short excursions, providing convenience, comfort, and reliability for all passengers."
  },
  {
    "name": "AC Cab Pune to Jejuri",
    "description": "AC Cab Pune to Jejuri offers a cool and comfortable travel experience, ideal for long-distance or day trips to Jejuri. Fully air-conditioned vehicles provide ample legroom and luggage space, making it suitable for families, corporate groups, or tourists. Experienced drivers ensure safe navigation through traffic, optimal routes, and timely pickups and drop-offs. This service combines comfort, efficiency, and convenience, ensuring passengers can enjoy their journey without any hassle or stress."
  },
  {
    "name": "Khandoba Temple Cab Pune",
    "description": "Khandoba Temple Cab Pune is tailored for pilgrims visiting the iconic Khandoba Temple in Jejuri. Comfortable, air-conditioned cabs with spacious interiors allow families and groups to travel conveniently from Pune. Professional chauffeurs guide travelers safely through the route, ensuring timely arrivals for temple darshan or religious ceremonies. Flexible booking options, affordable rates, and reliable service make this cab service perfect for devotional trips, one-day tours, and religious excursions."
  },
  {
    "name": "Family Cab Jejuri",
    "description": "Family Cab Jejuri provides a safe, comfortable, and stress-free travel option for families visiting Jejuri from Pune. Spacious interiors, air-conditioning, and ample luggage space make the journey relaxing for all family members. Professional chauffeurs ensure punctuality, safe driving, and a pleasant travel experience. Ideal for one-day trips, weekend excursions, or temple visits, this cab service prioritizes comfort, convenience, and affordability, making it the perfect choice for family travel."
  },
  {
    "name": "Affordable Jejuri Cab",
    "description": "Affordable Jejuri Cab offers budget-friendly travel options from Pune to Jejuri without compromising comfort or safety. Fully air-conditioned cabs with professional chauffeur service ensure a smooth ride at competitive rates. Suitable for families, tourists, and corporate travelers, this service combines affordability with convenience, punctuality, and reliability. Perfect for one-day trips, temple visits, and weekend excursions, passengers can enjoy a stress-free journey at a reasonable price."
  },
  {
    "name": "Chauffeur Driven Jejuri Cab",
    "description": "Chauffeur Driven Jejuri Cab ensures a professional and comfortable travel experience from Pune to Jejuri. Experienced drivers handle navigation, traffic, and route optimization, allowing passengers to relax or focus on work during the journey. Spacious, air-conditioned vehicles provide ample seating and luggage space, ideal for families, groups, or corporate travelers. This service prioritizes safety, comfort, and convenience, making each trip smooth, reliable, and enjoyable."
  },
  {
    "name": "Best Cab Pune to Jejuri",
    "description": "Best Cab Pune to Jejuri provides a premium and reliable service for passengers traveling from Pune to Jejuri. The cabs are fully air-conditioned, spacious, and maintained to ensure passenger comfort throughout the journey. Professional chauffeurs guarantee safe driving, timely arrivals, and courteous service. Ideal for temple visits, one-day trips, or group travel, this service combines quality, reliability, and convenience to make every journey memorable and hassle-free."
  },
  {
    "name": "Pune Jejuri Taxi",
    "description": "Pune Jejuri Taxi is a dependable travel solution for passengers seeking a comfortable and safe ride to Jejuri. Spacious, air-conditioned vehicles with modern interiors ensure a smooth journey. Professional chauffeurs manage all navigation and timing, ensuring punctual arrivals and stress-free travel. Perfect for families, tourists, or corporate travelers, this taxi service offers convenience, reliability, and comfort for all types of trips."
  },
  {
    "name": "Religious Tour Cab Pune",
    "description": "Religious Tour Cab Pune specializes in comfortable and convenient transportation for devotees traveling to Jejuri and other religious destinations. Fully air-conditioned cabs with spacious seating and luggage space ensure a pleasant journey. Experienced chauffeurs guide travelers safely and efficiently, making stops as needed for darshan, sightseeing, or rest. Suitable for families, groups, and individuals, this service combines convenience, reliability, and comfort for religious tours."
  },
  {
    "name": "Temple Darshan Cab Pune",
    "description": "Temple Darshan Cab Pune is designed for travelers visiting Jejuri’s Khandoba Temple for darshan or spiritual experiences. Air-conditioned, well-maintained cabs with spacious seating provide a comfortable ride for families, groups, or individual travelers. Professional drivers ensure safe and punctual travel while navigating city and highway routes. This service is ideal for one-day trips, weekend visits, and religious excursions, providing a seamless and enjoyable experience for all passengers."
  },
  {
    "name": "One Day Trip Cab Jejuri",
    "description": "One Day Trip Cab Jejuri offers a convenient and comfortable solution for travelers planning a short excursion from Pune to Jejuri. Air-conditioned cabs with spacious interiors and luggage space provide a relaxing travel experience. Professional chauffeurs ensure timely pickups, safe driving, and efficient route planning. Ideal for families, friends, or solo travelers, this service allows passengers to enjoy a hassle-free one-day trip to Jejuri and return to Pune the same day."
  },
  {
    "name": "Tourist Cab Jejuri",
    "description": "Tourist Cab Jejuri caters to travelers and tourists visiting Jejuri from Pune, offering a comfortable, safe, and air-conditioned journey. Spacious seating and luggage space make it ideal for families, groups, or solo travelers. Experienced chauffeurs provide punctual and courteous service, guiding passengers efficiently along the route. This service is suitable for sightseeing, religious visits, and one-day excursions, ensuring a memorable and stress-free travel experience."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune for Jejuri cabs allows travelers to reserve their vehicle conveniently from anywhere, at any time. Passengers can select pickup location, cab type, travel date, and timing, with instant confirmation. Air-conditioned, spacious cabs with professional chauffeurs provide a comfortable and safe ride. Suitable for one-day trips, temple visits, sightseeing, and weekend excursions, this online service combines technology, convenience, and professional transport to ensure hassle-free travel."
  },
  {
    "name": "Jejuri Travel Cab",
    "description": "Jejuri Travel Cab provides a reliable and comfortable option for passengers traveling from Pune to Jejuri for religious, leisure, or sightseeing purposes. Spacious, air-conditioned vehicles ensure comfort for families, groups, and corporate travelers. Professional chauffeurs handle all navigation, timing, and safety, ensuring a smooth and stress-free journey. Flexible packages for one-way, round trips, or customized itineraries make this service ideal for temple visits, pilgrimages, and weekend excursions."
  }
],
"tableData": [
  ["Pune to Jejuri Cab Booking", "Jejuri Cab from Pune"],
  ["AC Cab Pune to Jejuri", "Khandoba Temple Cab Pune"],
  ["Family Cab Jejuri", "Affordable Jejuri Cab"],
  ["Chauffeur Driven Jejuri Cab", "Best Cab Pune to Jejuri"],
  ["Pune Jejuri Taxi", "Religious Tour Cab Pune"],
  ["Temple Darshan Cab Pune", "One Day Trip Cab Jejuri"],
  ["Tourist Cab Jejuri", "Online Cab Booking Pune"],
  ["Jejuri Travel Cab", "—"]
]

,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Jejuri Cab Booking with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services from Pune to Jejuri, ideal for pilgrimages, family trips, group outings, and leisure travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced cabs for a smooth and enjoyable journey from Pune to Jejuri."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Pune–Jejuri route to ensure safe, punctual, and hassle‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Jejuri cab bookings, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary-related assistance."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized cab bookings based on your Pune to Jejuri travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for passengers."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Jejuri cab bookings."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab booking from Pune to Jejuri?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab services from Pune to Jejuri.'
  },
  {
    question: 'How can I book a cab from Pune to Jejuri?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of cabs are available for Pune to Jejuri travel?',
    answer: 'Sanavi Travels offers sedans, SUVs, and premium cars suitable for Pune to Jejuri trips.'
  },
  {
    question: 'Are drivers experienced for the Pune–Jejuri route?',
    answer: 'Yes, our professional drivers are familiar with the Pune to Jejuri route to ensure safe and smooth travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Pune and drop‑off in Jejuri.'
  },
  {
    question: 'Is the cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock cab services to match your travel schedule.'
  },
  {
    question: 'Are safety and hygiene protocols followed?',
    answer: 'All cabs are cleaned and sanitized regularly, and drivers follow strict safety and hygiene guidelines.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Jejuri journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh Patil',
    feedback: 'Booked a cab from Pune to Jejuri with Sanavi Travels. Very comfortable ride and excellent service throughout.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Great experience! The cab was clean, on‑time, and the driver was courteous. Highly recommend Sanavi Travels for Pune to Jejuri travel.',
    rating: 5
  }
];




















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jejuri Cab Booking - Sanavi Travels",
  "description": "Book Pune to Jejuri cabs with Sanavi Travels. AC and comfortable cabs for family trips, Khandoba temple visits, religious tours, one-day trips, pilgrimage travel, and chauffeur-driven journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Jejuri Cab Booking | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and comfortable cabs from Pune to Jejuri with Sanavi Travels. Perfect for Khandoba temple visits, family trips, religious tours, one-day excursions, and safe chauffeur-driven travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Jejuricabbooking;